import script from "./DocumentLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentLayout.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentLayout.vue?vue&type=style&index=0&id=1c1dd1d1&lang=scss"

const __exports__ = script;

export default __exports__